import React from 'react';
import { TableFooter, TableRow, TableCell } from '@mui/material';


interface INoResultsTableFooterProps {
    colSpan: number
    message: string
}

let NoResultsTableFooter = ({ colSpan, message }: INoResultsTableFooterProps) => {
    return (
        <TableFooter>
            <TableRow>
                <TableCell colSpan={colSpan}>
                    <i>{message}</i>
                </TableCell>
            </TableRow>
        </TableFooter>
    )
}

export default NoResultsTableFooter;